import React, { useEffect, useState } from 'react';
import { ChatInput as Input } from '@zurich-zurichat/chat-input';
import {
  ChipsGroup,
  FeedbackConfirmation,
  LoadingSpinner
} from 'app/components';
import { sendFeedback } from 'integration';
import {
  getBusinessArea,
  useAppSelector,
  useAppDispatch,
  setBusinessArea,
  setService,
  setFeedbackConfirmation,
  getBootstrapApp
} from 'app/redux';
import { smoothScrollingToAnchor } from 'app/utils';
import styles from './BusinessArea.module.scss';
import { ReactComponent as SettingsIcon } from 'app/assets/Icons/Settings.svg';
import { ReactComponent as HandClickIcon } from 'app/assets/Icons/HandClick.svg';

export const BusinessArea: React.FC = () => {
  const dispatch = useAppDispatch();
  const bootstrap = useAppSelector(getBootstrapApp);
  const currentBusinessArea = useAppSelector(getBusinessArea);
  const businessAreas = bootstrap.businessAreas;
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const hasActiveBusinessArea = Object.values(businessAreas).some(
      (area) => area.active
    );

    if (hasActiveBusinessArea) {
      setIsLoading(false);
    }
  }, [businessAreas]);

  const handleBusinessAreaSelection = ({
    status,
    value
  }: {
    status: boolean;
    value: string;
  }): void => {
    dispatch(setBusinessArea(value));
    dispatch(setService(undefined));
    if (currentBusinessArea === value && !status)
      dispatch(setBusinessArea(undefined));
    if (status) smoothScrollingToAnchor('services');
  };

  const handleSubmiFeedback = (feedback: string): void => {
    sendFeedback({
      origin: 'something-is-missing-business-services',
      feedback,
      businessArea: currentBusinessArea
    }).then(dispatch(setFeedbackConfirmation(true)));
  };

  return (
    <div className={styles['business-area']} id="businessareas">
      <div className={styles.wrapper}>
        <div className={styles['chips-area']}>
          <div className={styles['heading-container']}>
            <HandClickIcon />
            <h3 className={styles['heading-3']}>Choose your business area</h3>
            {isLoading ? (
              <LoadingSpinner
                containerStyle={{
                  position: 'relative',
                  left: '-1.5rem',
                  width: 'auto',
                  height: 'auto',
                  backdropFilter: 'unset'
                }}
                imageStyle={{ width: '6rem', height: '2rem', left: '2rem' }}
              />
            ) : null}
          </div>

          <div className={styles.chips}>
            {
              <ChipsGroup
                chipElements={businessAreas}
                selected={currentBusinessArea}
                onClick={handleBusinessAreaSelection}
              />
            }
          </div>
          <Input
            className={styles.input}
            inputProps={{ placeholder: 'Something is missing' }}
            onSubmit={(feedback) => {
              handleSubmiFeedback(feedback);
            }}
          />
        </div>

        <div className={styles.text}>
          <div className={styles['settings-icon']}>
            <SettingsIcon />
          </div>
          <h4 className={styles['heading-4']}>
            What are GenAI Business Services?
          </h4>
          <p>
            Introducing GenAI Business Services, a revolutionary solution
            leveraging the power of Generative AI to tackle essential business
            tasks. With its advanced capabilities, GenAI Business Services
            efficiently extracts crucial information from documents, performs
            document comparisons, conducts comprehensive searches, and generates
            concise summaries. Whether utilized in claims, underwriting, sales
            and distribution, or supporting functions, GenAI Business Services
            caters to the entire insurance value chain, driving efficiency and
            enhancing productivity.
          </p>
        </div>
        <FeedbackConfirmation />
      </div>
    </div>
  );
};
